import Vendor from './VendorContainer'
import WhiteLabelVendor from './WhiteLabelVendorContainer'
import { isWhiteLabel } from 'utils/whiteLabel'

let VendorComponent = Vendor

if (isWhiteLabel()) {
  VendorComponent = WhiteLabelVendor
}

export default VendorComponent
